module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    staticStyle: {
      "background-color": "#2b3033"
    },
    attrs: {
      "left-options": {
        showBack: false
      },
      "right-options": {
        showMore: true
      }
    }
  }, [_c('router-link', {
    staticClass: "Main_left",
    attrs: {
      "slot": "left",
      "to": "/home"
    },
    slot: "left"
  }, [_vm._v(" 返回")]), _vm._v("\n    登录\n  ")], 1), _vm._v(" "), _c('div', {
    staticClass: "bodyLogin"
  }, [_c('form', {
    staticClass: "formLogin",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.loginSub($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.use),
      expression: "use"
    }],
    staticClass: "Username",
    attrs: {
      "type": "text",
      "name": "username",
      "placeholder": "已验证邮箱/注册手机号"
    },
    domProps: {
      "value": (_vm.use)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.use = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [(!_vm.passShow) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paswd),
      expression: "paswd"
    }],
    staticClass: "Upassword",
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "密码"
    },
    domProps: {
      "value": (_vm.paswd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paswd = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.passShow) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paswd),
      expression: "paswd"
    }],
    staticClass: "Upassword",
    attrs: {
      "type": "text",
      "name": "password",
      "placeholder": "密码"
    },
    domProps: {
      "value": (_vm.paswd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paswd = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "pass-display pass-show",
    class: {
      'pass-show': !_vm.passShow, 'pass-hide': _vm.passShow
    },
    on: {
      "click": _vm.changePassDisplay
    }
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "loginNopsd clearfix"
  }, [_c('router-link', {
    staticClass: "left",
    attrs: {
      "to": "/forget"
    }
  }, [_vm._v("忘记密码？")]), _vm._v(" "), _c('router-link', {
    staticClass: "right",
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("立即注册")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_vm._v("还没有账号？")])], 1)]), _vm._v(" "), _c('toast', {
    staticClass: "zjwToast",
    attrs: {
      "type": _vm.tipType,
      "width": "4.5rem",
      "text": _vm.tiptxt,
      "time": 1800,
      "is-show-mask": "",
      "position": _vm.position
    },
    model: {
      value: (_vm.showPositionValue),
      callback: function($$v) {
        _vm.showPositionValue = $$v
      },
      expression: "showPositionValue"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-item"
  }, [_c('input', {
    attrs: {
      "type": "submit",
      "value": "登录"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de3ea48e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/login.vue
// module id = 3/rW
// module chunks = 1